var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.to)?_c('a',{class:_vm.linkClasses,attrs:{"href":_vm.href,"aria-current":_vm.ariaCurrent,"rel":_vm.isExternalLink ? 'noopener' : null},on:{"click":_vm.click}},[_vm._t("default")],2):_c('span',[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }